import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای موجودی لحظه‌ای

این فرم به شما اجازه می‌دهد تا موجودی لحظه‌ای مواد و قطعات را در انبارهای مختلف مشاهده نمایید.

## ۱. فیلتر موجودی
می‌توانید بر اساس انبار، متریال یا وضعیت پالت (موجود، مسدود شده و...) گزارش موجودی را فیلتر کنید.

## ۲. جزئیات
سیستم مجموع موجودی هر متریال در هر انبار را به تفکیک محاسبه و نمایش می‌دهد.

export default Layout;
